module.exports = __webpack_public_path__ + "static/media/walga-twl-logo-west-black.5e978c11.png";